// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(147 197 253 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.17 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: rgb(var(--c-gray-200) / 1); /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Poppins, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: rgb(var(--c-gray-400) / 1); /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: rgb(var(--c-gray-400) / 1); /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
  :root {
    color-scheme: light;

    /* gray */
    --c-gray-50: 249 250 251; /* #f9fafb */
    --c-gray-100: 243 244 246; /* #f3f4f6 */
    --c-gray-200: 229 231 235; /* #e5e7eb */
    --c-gray-300: 209 213 219; /* #d1d5db */
    --c-gray-400: 156 163 175; /* #9ca3af */
    --c-gray-500: 107 114 128; /* #6b7280 */
    --c-gray-600: 75 85 99; /* #4b5563 */
    --c-gray-700: 55 65 81; /* #374151 */
    --c-gray-800: 31 41 55; /* #1f2937 */
    --c-gray-900: 17 24 39; /* #111827 */
    --c-gray-950: 3 7 18; /* #030712 */
    /* blue */
    --c-blue-50: 239 246 255; /* #eff6ff */
    --c-blue-100: 219 234 254; /* #dbeafe */
    --c-blue-200: 191 219 254; /* #bfdbfe */
    --c-blue-300: 147 197 253; /* #93c5fd */
    --c-blue-400: 96 165 250; /* #60a5fa */
    --c-blue-500: 59 130 246; /* #3b82f6 */
    --c-blue-600: 37 99 235; /* #2563eb */
    --c-blue-700: 29 78 216; /* #1d4ed8 */
    --c-blue-800: 30 64 175; /* #1e40af */
    --c-blue-900: 30 58 138; /* #1e3a8a */
    --c-blue-950: 23 37 84; /* #172554 */
    /* green */
    --c-green-50: 240 253 244; /* #f0fdf4 */
    --c-green-100: 220 252 231; /* #dcfce7 */
    --c-green-200: 187 247 208; /* #bbf7d0 */
    --c-green-300: 134 239 172; /* #86efac */
    --c-green-400: 74 222 128; /* #4ade80 */
    --c-green-500: 34 197 94; /* #22c55e */
    --c-green-600: 22 163 74; /* #16a34a */
    --c-green-700: 21 128 61; /* #15803d */
    --c-green-800: 22 101 52; /* #166534 */
    --c-green-900: 20 83 45; /* #14532d */
    --c-green-950: 5 46 22; /* #052e16 */
    /* red */
    --c-red-50: 254 242 242; /* #fef2f2 */
    --c-red-100: 254 226 226; /* #fee2e2 */
    --c-red-200: 254 202 202; /* #fecaca */
    --c-red-300: 252 165 165; /* #fca5a5 */
    --c-red-400: 248 113 113; /* #f87171 */
    --c-red-500: 239 68 68; /* #ef4444 */
    --c-red-600: 220 38 38; /* #dc2626 */
    --c-red-700: 185 28 28; /* #b91c1c */
    --c-red-800: 153 27 27; /* #991b1b */
    --c-red-900: 127 29 29; /* #7f1d1d */
    --c-red-950: 69 10 10; /* #450a0a */
    /* yellow */
    --c-yellow-50: 254 252 232; /* #fefce8 */
    --c-yellow-100: 254 249 195; /* #fef9c3 */
    --c-yellow-200: 254 240 138; /* #fef08a */
    --c-yellow-300: 253 224 71; /* #fde047 */
    --c-yellow-400: 250 204 21; /* #facc15 */
    --c-yellow-500: 234 179 8; /* #eab308 */
    --c-yellow-600: 202 138 4; /* #ca8a04 */
    --c-yellow-700: 161 98 7; /* #a16207 */
    --c-yellow-800: 133 77 14; /* #854d0e */
    --c-yellow-900: 113 63 18; /* #713f12 */
    --c-yellow-950: 66 32 6; /* #422006 */
    /* amber */
    --c-amber-50: 255 251 235; /* #fffbeb */
    --c-amber-100: 254 243 199; /* #fef3c7 */
    --c-amber-200: 253 230 138; /* #fde68a */
    --c-amber-300: 252 211 77; /* #fcd34d */
    --c-amber-400: 251 191 36; /* #fbbf24 */
    --c-amber-500: 245 158 11; /* #f59e0b */
    --c-amber-600: 217 119 6; /* #d97706 */
    --c-amber-700: 180 83 9; /* #b45309 */
    --c-amber-800: 146 64 14; /* #92400e */
    --c-amber-900: 120 53 15; /* #78350f */
    --c-amber-950: 69 26 3; /* #451a03 */
    /* orange */
    --c-orange-50: 255 247 237; /* #fff7ed */
    --c-orange-100: 255 237 213; /* #ffedd5 */
    --c-orange-200: 254 215 170; /* #fed7aa */
    --c-orange-300: 253 186 116; /* #fdba74 */
    --c-orange-400: 251 146 60; /* #fb923c */
    --c-orange-500: 249 115 22; /* #f97316 */
    --c-orange-600: 234 88 12; /* #ea580c */
    --c-orange-700: 194 65 12; /* #c2410c */
    --c-orange-800: 154 52 18; /* #9a3412 */
    --c-orange-900: 124 45 18; /* #7c2d12 */
    --c-orange-950: 67 20 7; /* #431407 */
    /* purple */
    --c-purple-50: 250 245 255; /* #faf5ff */
    --c-purple-100: 243 232 255; /* #f3e8ff */
    --c-purple-200: 233 213 255; /* #e9d5ff */
    --c-purple-300: 216 180 254; /* #d8b4fe */
    --c-purple-400: 192 132 252; /* #c084fc */
    --c-purple-500: 168 85 247; /* #a855f7 */
    --c-purple-600: 147 51 234; /* #9333ea */
    --c-purple-700: 126 34 206; /* #7e22ce */
    --c-purple-800: 107 33 168; /* #6b21a8 */
    --c-purple-900: 88 28 135; /* #581c87 */
    --c-purple-950: 59 7 100; /* #3b0764 */
    /* pink */
    --c-pink-50: 253 242 248; /* #fdf2f8 */
    --c-pink-100: 252 231 243; /* #fce7f3 */
    --c-pink-200: 251 207 232; /* #fbcfe8 */
    --c-pink-300: 249 168 212; /* #f9a8d4 */
    --c-pink-400: 244 114 182; /* #f472b6 */
    --c-pink-500: 236 72 153; /* #ec4899 */
    --c-pink-600: 219 39 119; /* #db2777 */
    --c-pink-700: 190 24 93; /* #be185d */
    --c-pink-800: 157 23 77; /* #9d174d */
    --c-pink-900: 131 24 67; /* #831843 */
    --c-pink-950: 80 7 36; /* #500724 */

    /* Brand fills — carry white text. */
    --c-primary: 45 106 159;    /* #2d6a9f — blue, structure / trust */
    --c-secondary: 63 158 68;   /* #3f9e44 — green, care */
    --c-tertiary: 229 146 20;   /* #e59214 — amber, money / value */
    --c-highlight: 229 115 115; /* #e57373 — coral, remainder returns */
    --c-danger: 239 68 68;      /* #ef4444 */

    /* Brand ink — the same hues, but tuned to be read *on* a surface. */
    --primary-text: #2d6a9f;
    --secondary-text: #3f9e44;
    --tertiary-text: #e59214;

    /* Surfaces / ink (money-flow design system). */
    --c-paper: 245 248 252;   /* #f5f8fc */
    --c-card: 255 255 255;    /* #ffffff */
    --c-card-2: 238 243 249;  /* #eef3f9 */
    --c-ink: 31 45 61;        /* #1f2d3d */
    --c-ink-soft: 91 107 125; /* #5b6b7d */
    --c-line: 224 232 241;    /* #e0e8f1 */

    /* Footer band — dark in both themes. */
    --c-footer: 17 24 39;           /* #111827 */
    --c-footer-fg: 255 255 255;     /* #ffffff */
    --c-footer-surface: 31 41 55;   /* #1f2937 */
    --c-footer-line: 31 41 55;      /* #1f2937 */

    /* Legacy aliases kept for hand-written CSS and bg-[var(--…)] call sites. */
    --primary: #2d6a9f;
    --secondary: #3f9e44;
    --tertiary: #e59214;
    --highlight: #e57373;
    --coral: #e57373;
    --paper: #f5f8fc;
    --card: #ffffff;
    --card-2: #eef3f9;
    --ink: #1f2d3d;
    --ink-soft: #5b6b7d;
    --line: #e0e8f1;
    --background: #ffffff;
    --foreground: #333333;
    --error: #d32020;
    --warning: #d95020;
    --success: #3f9e44;

    /* Component-level surfaces that must not simply invert. */
    --card-bg: #ffffff;
    --card-border: #e0e0e0;
    --card-border-hover: #d0d0d0;
    --btn-primary-hover: #245a8a;
    --btn-secondary-hover: #3d8b40;
    --accent-from: #facc15;
    --accent-to: #fb923c;
    --accent-from-hover: #eab308;
    --accent-to-hover: #f97316;
    --accent-ink: #713f12;
  }

  :root[data-theme="dark"] {
    color-scheme: dark;

    /* gray */
    --c-gray-50: 18 25 36; /* #121924 */
    --c-gray-100: 23 32 50; /* #172032 */
    --c-gray-200: 34 45 63; /* #222d3f */
    --c-gray-300: 47 61 82; /* #2f3d52 */
    --c-gray-400: 125 143 166; /* #7d8fa6 */
    --c-gray-500: 148 165 186; /* #94a5ba */
    --c-gray-600: 173 188 205; /* #adbccd */
    --c-gray-700: 200 211 224; /* #c8d3e0 */
    --c-gray-800: 227 233 241; /* #e3e9f1 */
    --c-gray-900: 241 245 250; /* #f1f5fa */
    --c-gray-950: 248 250 252; /* #f8fafc */
    /* blue */
    --c-blue-50: 16 29 46; /* #101d2e */
    --c-blue-100: 20 38 58; /* #14263a */
    --c-blue-200: 28 53 80; /* #1c3550 */
    --c-blue-300: 39 73 108; /* #27496c */
    --c-blue-400: 74 140 207; /* #4a8ccf */
    --c-blue-500: 98 164 232; /* #62a4e8 */
    --c-blue-600: 130 187 243; /* #82bbf3 */
    --c-blue-700: 166 207 248; /* #a6cff8 */
    --c-blue-800: 198 225 251; /* #c6e1fb */
    --c-blue-900: 223 238 253; /* #dfeefd */
    --c-blue-950: 240 247 255; /* #f0f7ff */
    /* green */
    --c-green-50: 14 31 22; /* #0e1f16 */
    --c-green-100: 18 41 29; /* #12291d */
    --c-green-200: 26 58 41; /* #1a3a29 */
    --c-green-300: 36 80 56; /* #245038 */
    --c-green-400: 69 168 107; /* #45a86b */
    --c-green-500: 85 191 126; /* #55bf7e */
    --c-green-600: 116 211 150; /* #74d396 */
    --c-green-700: 153 224 178; /* #99e0b2 */
    --c-green-800: 191 236 205; /* #bfeccd */
    --c-green-900: 221 245 229; /* #ddf5e5 */
    --c-green-950: 240 251 244; /* #f0fbf4 */
    /* red */
    --c-red-50: 36 19 21; /* #241315 */
    --c-red-100: 48 25 27; /* #30191b */
    --c-red-200: 69 37 39; /* #452527 */
    --c-red-300: 94 51 53; /* #5e3335 */
    --c-red-400: 224 113 111; /* #e0716f */
    --c-red-500: 239 132 130; /* #ef8482 */
    --c-red-600: 243 157 155; /* #f39d9b */
    --c-red-700: 247 184 182; /* #f7b8b6 */
    --c-red-800: 250 210 209; /* #fad2d1 */
    --c-red-900: 252 231 230; /* #fce7e6 */
    --c-red-950: 254 244 243; /* #fef4f3 */
    /* yellow */
    --c-yellow-50: 36 31 13; /* #241f0d */
    --c-yellow-100: 46 40 17; /* #2e2811 */
    --c-yellow-200: 69 59 24; /* #453b18 */
    --c-yellow-300: 92 79 33; /* #5c4f21 */
    --c-yellow-400: 212 172 47; /* #d4ac2f */
    --c-yellow-500: 226 189 71; /* #e2bd47 */
    --c-yellow-600: 236 202 106; /* #ecca6a */
    --c-yellow-700: 242 217 146; /* #f2d992 */
    --c-yellow-800: 247 230 184; /* #f7e6b8 */
    --c-yellow-900: 251 242 217; /* #fbf2d9 */
    --c-yellow-950: 253 249 238; /* #fdf9ee */
    /* amber */
    --c-amber-50: 38 29 11; /* #261d0b */
    --c-amber-100: 49 37 14; /* #31250e */
    --c-amber-200: 73 55 21; /* #493715 */
    --c-amber-300: 97 73 29; /* #61491d */
    --c-amber-400: 223 160 44; /* #dfa02c */
    --c-amber-500: 236 178 69; /* #ecb245 */
    --c-amber-600: 243 195 104; /* #f3c368 */
    --c-amber-700: 248 213 144; /* #f8d590 */
    --c-amber-800: 251 228 183; /* #fbe4b7 */
    --c-amber-900: 253 241 216; /* #fdf1d8 */
    --c-amber-950: 254 248 237; /* #fef8ed */
    /* orange */
    --c-orange-50: 39 26 15; /* #271a0f */
    --c-orange-100: 50 33 20; /* #322114 */
    --c-orange-200: 73 48 28; /* #49301c */
    --c-orange-300: 97 64 36; /* #614024 */
    --c-orange-400: 224 138 68; /* #e08a44 */
    --c-orange-500: 238 157 91; /* #ee9d5b */
    --c-orange-600: 245 180 126; /* #f5b47e */
    --c-orange-700: 249 201 162; /* #f9c9a2 */
    --c-orange-800: 252 220 195; /* #fcdcc3 */
    --c-orange-900: 253 236 219; /* #fdecdb */
    --c-orange-950: 254 246 239; /* #fef6ef */
    /* purple */
    --c-purple-50: 30 19 48; /* #1e1330 */
    --c-purple-100: 38 25 61; /* #26193d */
    --c-purple-200: 54 37 85; /* #362555 */
    --c-purple-300: 72 51 111; /* #48336f */
    --c-purple-400: 176 136 232; /* #b088e8 */
    --c-purple-500: 192 157 240; /* #c09df0 */
    --c-purple-600: 205 178 244; /* #cdb2f4 */
    --c-purple-700: 220 200 248; /* #dcc8f8 */
    --c-purple-800: 233 220 251; /* #e9dcfb */
    --c-purple-900: 243 236 253; /* #f3ecfd */
    --c-purple-950: 250 247 254; /* #faf7fe */
    /* pink */
    --c-pink-50: 43 18 32; /* #2b1220 */
    --c-pink-100: 55 24 42; /* #37182a */
    --c-pink-200: 78 36 59; /* #4e243b */
    --c-pink-300: 103 49 78; /* #67314e */
    --c-pink-400: 236 132 182; /* #ec84b6 */
    --c-pink-500: 242 153 195; /* #f299c3 */
    --c-pink-600: 245 176 209; /* #f5b0d1 */
    --c-pink-700: 248 200 223; /* #f8c8df */
    --c-pink-800: 251 221 236; /* #fbddec */
    --c-pink-900: 253 237 244; /* #fdedf4 */
    --c-pink-950: 254 246 250; /* #fef6fa */

    /* Brand fills. Nudged brighter so they read on a dark ground while still
       clearing 4.5:1 against the white text they carry. */
    --c-primary: 53 121 173;    /* #3579ad */
    --c-secondary: 47 124 53;   /* #2f7c35 */
    --c-tertiary: 166 105 12;   /* #a6690c */
    --c-highlight: 176 78 78;   /* #b04e4e */
    --c-danger: 192 57 47;      /* #c0392f */

    /* Brand ink — lightened for legibility against dark surfaces. */
    --primary-text: #7ab6e8;
    --secondary-text: #6cc873;
    --tertiary-text: #f0b452;

    /* Surfaces / ink. */
    --c-paper: 21 29 41;      /* #151d29 */
    --c-card: 26 36 51;       /* #1a2433 */
    --c-card-2: 33 44 61;     /* #212c3d */
    --c-ink: 227 233 241;     /* #e3e9f1 */
    --c-ink-soft: 167 182 200; /* #a7b6c8 */
    --c-line: 42 54 72;       /* #2a3648 */

    /* Footer sits a step *below* the page so it still reads as a base band. */
    --c-footer: 13 19 28;           /* #0d131c */
    --c-footer-fg: 200 211 224;     /* #c8d3e0 */
    --c-footer-surface: 26 35 48;   /* #1a2330 */
    --c-footer-line: 33 44 59;      /* #212c3b */

    --primary: #3579ad;
    --secondary: #2f7c35;
    --tertiary: #a6690c;
    --highlight: #b04e4e;
    --coral: #d98a8a;
    --paper: #151d29;
    --card: #1a2433;
    --card-2: #212c3d;
    --ink: #e3e9f1;
    --ink-soft: #a7b6c8;
    --line: #2a3648;
    --background: #0f151f;
    --foreground: #c8d3e0;
    --error: #f08a86;
    --warning: #ee9d5b;
    --success: #6cc873;

    --card-bg: #1a2433;
    --card-border: #2a3648;
    --card-border-hover: #3a4a60;
    --btn-primary-hover: #4189bd;
    --btn-secondary-hover: #388d3f;
    --accent-from: #87610a;
    --accent-to: #95530f;
    --accent-from-hover: #9c710c;
    --accent-to-hover: #aa6111;
    --accent-ink: #fdf6e3;
  }

  body {
    font-family: 'Poppins', 'Century Gothic', ui-rounded, system-ui, -apple-system, sans-serif;
    background-color: var(--background);
    color: var(--foreground);
  }

  /* Text-entry controls carry no background class anywhere in the app, so under
     \`color-scheme: dark\` the browser fills them with its own off-palette grey. Painting
     them here keeps every form on the theme's surfaces without touching call sites.
     Checkboxes and radios are excluded — they still want the native control rendering. */
  input:not([type="checkbox"]):not([type="radio"]),
  textarea,
  select {
    background-color: var(--card-bg);
    color: var(--foreground);
  }

  input::-moz-placeholder, textarea::-moz-placeholder {
    color: rgb(var(--c-gray-400));
    opacity: 1;
  }

  input::placeholder,
  textarea::placeholder {
    color: rgb(var(--c-gray-400));
    opacity: 1;
  }
.\\!container {
  width: 100% !important;
  margin-right: auto !important;
  margin-left: auto !important;
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important;
}
.container {
  width: 100%;
  margin-right: auto;
  margin-left: auto;
  padding-right: 1.5rem;
  padding-left: 1.5rem;
}
/* One smooth cap for the content column, rather than Tailwind's breakpoint-stepped
     max-widths — the column grows with the viewport and simply stops here. \`center: true\`
     in the config supplies the auto margins. Below the cap, max-width has no effect and the
     column is fluid (100% minus the config's padding), so it collapses to smaller screens
     without a separate media query. Section backgrounds stay full-bleed; only what sits
     inside them is constrained. */
.\\!container {
    max-width: 1024px !important;
  }
.container {
    max-width: 1024px;
  }
.btn-primary {
  border-radius: 9999px;
  border-width: 0px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
    background-color: var(--primary);
    color: white;
}
.btn-primary:hover {
    background-color: var(--btn-primary-hover);
  }
.btn-secondary {
  border-radius: 9999px;
  border-width: 0px;
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  font-weight: 500;
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
    background-color: var(--secondary);
    color: white;
}
.btn-secondary:hover {
    background-color: var(--btn-secondary-hover);
  }
/* Amber gradient CTA. Kept as its own component because a mirrored yellow/orange ramp
     would leave a bright fill under near-white text; both stops move together instead. */
.btn-accent {
    background-image: linear-gradient(to right, var(--accent-from), var(--accent-to));
    color: var(--accent-ink);
  }
.btn-accent:hover {
    background-image: linear-gradient(to right, var(--accent-from-hover), var(--accent-to-hover));
  }
.highlight-text {
    color: var(--primary-text);
  }
.section-divider {
    height: 4px;
    background: linear-gradient(90deg, transparent 0%, var(--primary) 50%, transparent 100%);
    margin: 0 auto;
    width: 70%;
  }
.card {
  border-radius: 0.5rem;
  border-width: 1px;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 200ms;
    background-color: var(--card-bg);
    border-color: var(--card-border);
}
.card:hover {
    border-color: var(--card-border-hover);
  }
.story-paragraph {
    text-align: justify;
    -moz-text-align-last: center;
         text-align-last: center;
    hyphens: auto;
    word-spacing: 1pt;
  }
@media (max-width: 600px) {
    .story-paragraph {
      hyphens: none;
    }
  }
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.pointer-events-none {
  pointer-events: none;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.sticky {
  position: sticky;
}
.inset-0 {
  inset: 0px;
}
.inset-3 {
  inset: 0.75rem;
}
.inset-x-0 {
  left: 0px;
  right: 0px;
}
.bottom-2 {
  bottom: 0.5rem;
}
.bottom-6 {
  bottom: 1.5rem;
}
.left-0 {
  left: 0px;
}
.left-1\\/2 {
  left: 50%;
}
.left-2 {
  left: 0.5rem;
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
.top-full {
  top: 100%;
}
.z-10 {
  z-index: 10;
}
.z-50 {
  z-index: 50;
}
.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
.-mr-2 {
  margin-right: -0.5rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-10 {
  margin-bottom: 2.5rem;
}
.mb-12 {
  margin-bottom: 3rem;
}
.mb-16 {
  margin-bottom: 4rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.mr-1 {
  margin-right: 0.25rem;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mr-4 {
  margin-right: 1rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-10 {
  margin-top: 2.5rem;
}
.mt-12 {
  margin-top: 3rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-20 {
  margin-top: 5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-7 {
  margin-top: 1.75rem;
}
.mt-8 {
  margin-top: 2rem;
}
.mt-auto {
  margin-top: auto;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.aspect-\\[4\\/3\\] {
  aspect-ratio: 4/3;
}
.h-1\\.5 {
  height: 0.375rem;
}
.h-10 {
  height: 2.5rem;
}
.h-12 {
  height: 3rem;
}
.h-14 {
  height: 3.5rem;
}
.h-16 {
  height: 4rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-20 {
  height: 5rem;
}
.h-3 {
  height: 0.75rem;
}
.h-4 {
  height: 1rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-full {
  height: 100%;
}
.max-h-full {
  max-height: 100%;
}
.min-h-screen {
  min-height: 100vh;
}
.w-1\\.5 {
  width: 0.375rem;
}
.w-10 {
  width: 2.5rem;
}
.w-12 {
  width: 3rem;
}
.w-14 {
  width: 3.5rem;
}
.w-16 {
  width: 4rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-20 {
  width: 5rem;
}
.w-28 {
  width: 7rem;
}
.w-4 {
  width: 1rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-8 {
  width: 2rem;
}
.w-auto {
  width: auto;
}
.w-full {
  width: 100%;
}
.w-px {
  width: 1px;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[14rem\\] {
  min-width: 14rem;
}
.min-w-\\[420px\\] {
  min-width: 420px;
}
.max-w-2xl {
  max-width: 42rem;
}
.max-w-3xl {
  max-width: 48rem;
}
.max-w-6xl {
  max-width: 72rem;
}
.max-w-7xl {
  max-width: 80rem;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-prose {
  max-width: 65ch;
}
.flex-1 {
  flex: 1 1 0%;
}
.shrink {
  flex-shrink: 1;
}
.shrink-0 {
  flex-shrink: 0;
}
.flex-grow {
  flex-grow: 1;
}
.-translate-x-1\\/2 {
  --tw-translate-x: -50%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-180 {
  --tw-rotate: 180deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.rotate-45 {
  --tw-rotate: 45deg;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.transform {
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-not-allowed {
  cursor: not-allowed;
}
.cursor-pointer {
  cursor: pointer;
}
.scroll-mt-20 {
  scroll-margin-top: 5rem;
}
.scroll-mt-28 {
  scroll-margin-top: 7rem;
}
.list-inside {
  list-style-position: inside;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-center {
  align-items: center;
}
.items-baseline {
  align-items: baseline;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-0\\.5 {
  gap: 0.125rem;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-1\\.5 {
  gap: 0.375rem;
}
.gap-10 {
  gap: 2.5rem;
}
.gap-12 {
  gap: 3rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-8 {
  gap: 2rem;
}
.gap-px {
  gap: 1px;
}
.gap-x-5 {
  -moz-column-gap: 1.25rem;
       column-gap: 1.25rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.space-x-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(0.75rem * var(--tw-space-x-reverse));
  margin-left: calc(0.75rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1rem * var(--tw-space-x-reverse));
  margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-x-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-x-reverse: 0;
  margin-right: calc(1.5rem * var(--tw-space-x-reverse));
  margin-left: calc(1.5rem * calc(1 - var(--tw-space-x-reverse)));
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-12 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(3rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(3rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-20 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(5rem * var(--tw-space-y-reverse));
}
.space-y-24 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(6rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(6rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-gray-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(var(--c-gray-100) / var(--tw-divide-opacity, 1));
}
.self-start {
  align-self: flex-start;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.break-words {
  overflow-wrap: break-word;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-none {
  border-radius: 0px;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-2 {
  border-width: 2px;
}
.border-4 {
  border-width: 4px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-b-2 {
  border-bottom-width: 2px;
}
.border-l-2 {
  border-left-width: 2px;
}
.border-l-4 {
  border-left-width: 4px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-none {
  border-style: none;
}
.border-\\[\\#13233f\\] {
  --tw-border-opacity: 1;
  border-color: rgb(19 35 63 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d4af37\\] {
  --tw-border-opacity: 1;
  border-color: rgb(212 175 55 / var(--tw-border-opacity, 1));
}
.border-\\[\\#d4af37\\]\\/30 {
  border-color: rgb(212 175 55 / 0.3);
}
.border-\\[\\#d4af37\\]\\/50 {
  border-color: rgb(212 175 55 / 0.5);
}
.border-\\[\\#d4af37\\]\\/70 {
  border-color: rgb(212 175 55 / 0.7);
}
.border-\\[var\\(--primary\\)\\] {
  border-color: var(--primary);
}
.border-\\[var\\(--secondary\\)\\] {
  border-color: var(--secondary);
}
.border-\\[var\\(--tertiary\\)\\] {
  border-color: var(--tertiary);
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-amber-200) / var(--tw-border-opacity, 1));
}
.border-blue-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-blue-200) / var(--tw-border-opacity, 1));
}
.border-current {
  border-color: currentColor;
}
.border-footer-line {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-footer-line) / var(--tw-border-opacity, 1));
}
.border-gray-100 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-100) / var(--tw-border-opacity, 1));
}
.border-gray-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-200) / var(--tw-border-opacity, 1));
}
.border-gray-300 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-300) / var(--tw-border-opacity, 1));
}
.border-green-100 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-green-100) / var(--tw-border-opacity, 1));
}
.border-green-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-green-200) / var(--tw-border-opacity, 1));
}
.border-green-600 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-green-600) / var(--tw-border-opacity, 1));
}
.border-line {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-line) / var(--tw-border-opacity, 1));
}
.border-primary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-primary) / var(--tw-border-opacity, 1));
}
.border-purple-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-purple-200) / var(--tw-border-opacity, 1));
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-red-200) / var(--tw-border-opacity, 1));
}
.border-secondary {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-secondary) / var(--tw-border-opacity, 1));
}
.border-tertiary\\/40 {
  border-color: rgb(var(--c-tertiary) / 0.4);
}
.border-white\\/10 {
  border-color: rgb(255 255 255 / 0.1);
}
.border-white\\/15 {
  border-color: rgb(255 255 255 / 0.15);
}
.border-white\\/25 {
  border-color: rgb(255 255 255 / 0.25);
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-yellow-200) / var(--tw-border-opacity, 1));
}
.border-t-primary {
  --tw-border-opacity: 1;
  border-top-color: rgb(var(--c-primary) / var(--tw-border-opacity, 1));
}
.bg-\\[\\#13233f\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(19 35 63 / var(--tw-bg-opacity, 1));
}
.bg-\\[\\#d4af37\\] {
  --tw-bg-opacity: 1;
  background-color: rgb(212 175 55 / var(--tw-bg-opacity, 1));
}
.bg-\\[var\\(--primary\\)\\] {
  background-color: var(--primary);
}
.bg-\\[var\\(--secondary\\)\\] {
  background-color: var(--secondary);
}
.bg-\\[var\\(--tertiary\\)\\] {
  background-color: var(--tertiary);
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-amber-50) / var(--tw-bg-opacity, 1));
}
.bg-black {
  --tw-bg-opacity: 1;
  background-color: rgb(0 0 0 / var(--tw-bg-opacity, 1));
}
.bg-black\\/60 {
  background-color: rgb(0 0 0 / 0.6);
}
.bg-blue-300 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-300) / var(--tw-bg-opacity, 1));
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-blue-50) / var(--tw-bg-opacity, 1));
}
.bg-card {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-card) / var(--tw-bg-opacity, 1));
}
.bg-card\\/60 {
  background-color: rgb(var(--c-card) / 0.6);
}
.bg-card\\/80 {
  background-color: rgb(var(--c-card) / 0.8);
}
.bg-current {
  background-color: currentColor;
}
.bg-footer {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-footer) / var(--tw-bg-opacity, 1));
}
.bg-footer-surface {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-footer-surface) / var(--tw-bg-opacity, 1));
}
.bg-gray-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-100) / var(--tw-bg-opacity, 1));
}
.bg-gray-200 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-200) / var(--tw-bg-opacity, 1));
}
.bg-gray-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-50) / var(--tw-bg-opacity, 1));
}
.bg-gray-700 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-700) / var(--tw-bg-opacity, 1));
}
.bg-green-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-green-50) / var(--tw-bg-opacity, 1));
}
.bg-paper {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-paper) / var(--tw-bg-opacity, 1));
}
.bg-primary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-primary) / var(--tw-bg-opacity, 1));
}
.bg-red-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-100) / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-red-50) / var(--tw-bg-opacity, 1));
}
.bg-secondary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-secondary) / var(--tw-bg-opacity, 1));
}
.bg-tertiary {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-tertiary) / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-white\\/10 {
  background-color: rgb(255 255 255 / 0.1);
}
.bg-white\\/5 {
  background-color: rgb(255 255 255 / 0.05);
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-yellow-50) / var(--tw-bg-opacity, 1));
}
.bg-opacity-10 {
  --tw-bg-opacity: 0.1;
}
.bg-gradient-to-br {
  background-image: linear-gradient(to bottom right, var(--tw-gradient-stops));
}
.bg-gradient-to-r {
  background-image: linear-gradient(to right, var(--tw-gradient-stops));
}
.from-blue-50 {
  --tw-gradient-from: rgb(var(--c-blue-50) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-blue-50) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-gray-50 {
  --tw-gradient-from: rgb(var(--c-gray-50) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-gray-50) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-100 {
  --tw-gradient-from: rgb(var(--c-green-100) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-green-100) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50 {
  --tw-gradient-from: rgb(var(--c-green-50) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-green-50) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-green-50\\/30 {
  --tw-gradient-from: rgb(var(--c-green-50) / 0.3) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-green-50) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-purple-50 {
  --tw-gradient-from: rgb(var(--c-purple-50) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-purple-50) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.from-yellow-50 {
  --tw-gradient-from: rgb(var(--c-yellow-50) / 1) var(--tw-gradient-from-position);
  --tw-gradient-to: rgb(var(--c-yellow-50) / 0) var(--tw-gradient-to-position);
  --tw-gradient-stops: var(--tw-gradient-from), var(--tw-gradient-to);
}
.to-blue-50 {
  --tw-gradient-to: rgb(var(--c-blue-50) / 1) var(--tw-gradient-to-position);
}
.to-blue-50\\/30 {
  --tw-gradient-to: rgb(var(--c-blue-50) / 0.3) var(--tw-gradient-to-position);
}
.to-green-200 {
  --tw-gradient-to: rgb(var(--c-green-200) / 1) var(--tw-gradient-to-position);
}
.to-green-50 {
  --tw-gradient-to: rgb(var(--c-green-50) / 1) var(--tw-gradient-to-position);
}
.to-orange-50 {
  --tw-gradient-to: rgb(var(--c-orange-50) / 1) var(--tw-gradient-to-position);
}
.to-pink-50 {
  --tw-gradient-to: rgb(var(--c-pink-50) / 1) var(--tw-gradient-to-position);
}
.to-purple-50 {
  --tw-gradient-to: rgb(var(--c-purple-50) / 1) var(--tw-gradient-to-position);
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.px-12 {
  padding-left: 3rem;
  padding-right: 3rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.px-6 {
  padding-left: 1.5rem;
  padding-right: 1.5rem;
}
.px-8 {
  padding-left: 2rem;
  padding-right: 2rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-10 {
  padding-top: 2.5rem;
  padding-bottom: 2.5rem;
}
.py-12 {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.py-16 {
  padding-top: 4rem;
  padding-bottom: 4rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-20 {
  padding-top: 5rem;
  padding-bottom: 5rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-5 {
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.py-8 {
  padding-top: 2rem;
  padding-bottom: 2rem;
}
.pb-20 {
  padding-bottom: 5rem;
}
.pb-24 {
  padding-bottom: 6rem;
}
.pl-4 {
  padding-left: 1rem;
}
.pt-1 {
  padding-top: 0.25rem;
}
.pt-10 {
  padding-top: 2.5rem;
}
.pt-16 {
  padding-top: 4rem;
}
.pt-20 {
  padding-top: 5rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.pt-6 {
  padding-top: 1.5rem;
}
.pt-8 {
  padding-top: 2rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-4xl {
  font-size: 2.25rem;
  line-height: 2.5rem;
}
.text-6xl {
  font-size: 3.75rem;
  line-height: 1;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-extrabold {
  font-weight: 800;
}
.font-medium {
  font-weight: 500;
}
.font-normal {
  font-weight: 400;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.not-italic {
  font-style: normal;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-relaxed {
  line-height: 1.625;
}
.leading-snug {
  line-height: 1.375;
}
.leading-tight {
  line-height: 1.25;
}
.tracking-\\[0\\.5em\\] {
  letter-spacing: 0.5em;
}
.tracking-tight {
  letter-spacing: -0.025em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-\\[\\#13233f\\] {
  --tw-text-opacity: 1;
  color: rgb(19 35 63 / var(--tw-text-opacity, 1));
}
.text-\\[\\#9cc4ec\\] {
  --tw-text-opacity: 1;
  color: rgb(156 196 236 / var(--tw-text-opacity, 1));
}
.text-\\[\\#a8a397\\] {
  --tw-text-opacity: 1;
  color: rgb(168 163 151 / var(--tw-text-opacity, 1));
}
.text-\\[\\#c9d6e8\\] {
  --tw-text-opacity: 1;
  color: rgb(201 214 232 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d4af37\\] {
  --tw-text-opacity: 1;
  color: rgb(212 175 55 / var(--tw-text-opacity, 1));
}
.text-\\[\\#d6d3cb\\] {
  --tw-text-opacity: 1;
  color: rgb(214 211 203 / var(--tw-text-opacity, 1));
}
.text-\\[\\#e9e4d6\\] {
  --tw-text-opacity: 1;
  color: rgb(233 228 214 / var(--tw-text-opacity, 1));
}
.text-\\[var\\(--primary\\)\\] {
  color: var(--primary);
}
.text-\\[var\\(--secondary\\)\\] {
  color: var(--secondary);
}
.text-\\[var\\(--tertiary\\)\\] {
  color: var(--tertiary);
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-amber-700) / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-amber-800) / var(--tw-text-opacity, 1));
}
.text-black {
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-600) / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-700) / var(--tw-text-opacity, 1));
}
.text-blue-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-800) / var(--tw-text-opacity, 1));
}
.text-blue-900 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-blue-900) / var(--tw-text-opacity, 1));
}
.text-footer-fg {
  --tw-text-opacity: 1;
  color: rgb(var(--c-footer-fg) / var(--tw-text-opacity, 1));
}
.text-gray-400 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-400) / var(--tw-text-opacity, 1));
}
.text-gray-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-500) / var(--tw-text-opacity, 1));
}
.text-gray-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-600) / var(--tw-text-opacity, 1));
}
.text-gray-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-700) / var(--tw-text-opacity, 1));
}
.text-gray-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-800) / var(--tw-text-opacity, 1));
}
.text-gray-900 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-900) / var(--tw-text-opacity, 1));
}
.text-green-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-500) / var(--tw-text-opacity, 1));
}
.text-green-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-600) / var(--tw-text-opacity, 1));
}
.text-green-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-700) / var(--tw-text-opacity, 1));
}
.text-green-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-green-800) / var(--tw-text-opacity, 1));
}
.text-primary {
  --tw-text-opacity: 1;
  color: rgb(var(--c-primary) / var(--tw-text-opacity, 1));
}
.text-purple-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-purple-800) / var(--tw-text-opacity, 1));
}
.text-red-500 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-red-500) / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-red-600) / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-red-700) / var(--tw-text-opacity, 1));
}
.text-secondary {
  --tw-text-opacity: 1;
  color: rgb(var(--c-secondary) / var(--tw-text-opacity, 1));
}
.text-tertiary {
  --tw-text-opacity: 1;
  color: rgb(var(--c-tertiary) / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-600 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-yellow-600) / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-yellow-700) / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(var(--c-yellow-800) / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.accent-primary {
  accent-color: rgb(var(--c-primary) / 1);
}
.opacity-0 {
  opacity: 0;
}
.opacity-100 {
  opacity: 1;
}
.opacity-50 {
  opacity: 0.5;
}
.opacity-60 {
  opacity: 0.6;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.opacity-90 {
  opacity: 0.9;
}
.shadow {
  --tw-shadow: 0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-lg {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-md {
  --tw-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 4px 6px -1px var(--tw-shadow-color), 0 2px 4px -2px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.ring-1 {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(1px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.ring-\\[\\#d4af37\\]\\/30 {
  --tw-ring-color: rgb(212 175 55 / 0.3);
}
.ring-\\[\\#d4af37\\]\\/40 {
  --tw-ring-color: rgb(212 175 55 / 0.4);
}
.ring-line {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-line) / var(--tw-ring-opacity, 1));
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-\\[opacity\\2c visibility\\] {
  transition-property: opacity,visibility;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-all {
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-colors {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-1000 {
  transition-duration: 1000ms;
}
.duration-200 {
  transition-duration: 200ms;
}
.duration-700 {
  transition-duration: 700ms;
}
.ease-out {
  transition-timing-function: cubic-bezier(0, 0, 0.2, 1);
}
/* Brand colour used as *ink* rather than as a fill: these resolve to the lightened
     variant in dark mode, where the fill-weight brand blue is unreadable on a dark surface.

     Each rule deliberately shadows the identical utility Tailwind generates from the config
     colour of the same name — same specificity, emitted later, so this one wins. \`bg-primary\`
     and \`border-primary\` are left alone and keep the fill weight. Consequence: a \`dark:\`
     variant of these three would lose to the rules below; the tokens make it unnecessary. */
.text-primary {
    color: var(--primary-text);
  }
.text-secondary {
    color: var(--secondary-text);
  }
.text-tertiary {
    color: var(--tertiary-text);
  }
.\\[grid-area\\:1\\/1\\] {
  grid-area: 1/1;
}

/* ---------------------------------------------------------------------------
   Theming.

   Every palette value lives in a CSS variable as "R G B" channels (Tailwind wraps
   them in rgb(… / <alpha-value>) — see tailwind.config.js). The light block below is
   the design system exactly as it shipped; the dark block re-points the same names.

   The dark neutral/accent ramps are *mirrors* of the light ones: shades 50–300 are
   recessive surfaces and 400–950 are progressively lighter foregrounds. That keeps
   the relative ordering a component already relies on — \`bg-gray-50\` stays a step
   back from \`bg-card\`, \`text-gray-700\` stays body copy — so existing markup themes
   itself with no \`dark:\` variants. Two exceptions are given their own tokens because
   inverting them would be wrong: the footer (a dark band in both themes) and solid
   brand/accent fills that must keep carrying white text.

   \`data-theme\` is written to <html> by src/theme/ThemeProvider.tsx, which resolves the
   "auto" preference from prefers-color-scheme. public/index.html sets it before first
   paint so the page never flashes the wrong theme.
   --------------------------------------------------------------------------- */

.first\\:border-0:first-child {
  border-width: 0px;
}

.first\\:pt-0:first-child {
  padding-top: 0px;
}

.last\\:border-0:last-child {
  border-width: 0px;
}

.last\\:pb-0:last-child {
  padding-bottom: 0px;
}

.focus-within\\:ring-2:focus-within {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-within\\:ring-primary:focus-within {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-primary) / var(--tw-ring-opacity, 1));
}

.hover\\:scale-105:hover {
  --tw-scale-x: 1.05;
  --tw-scale-y: 1.05;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}

.hover\\:border-\\[\\#d4af37\\]:hover {
  --tw-border-opacity: 1;
  border-color: rgb(212 175 55 / var(--tw-border-opacity, 1));
}

.hover\\:border-\\[var\\(--primary\\)\\]:hover {
  border-color: var(--primary);
}

.hover\\:border-gray-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(var(--c-gray-400) / var(--tw-border-opacity, 1));
}

.hover\\:bg-\\[\\#e2c15a\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(226 193 90 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-\\[\\#e6eef8\\]:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(230 238 248 / var(--tw-bg-opacity, 1));
}

.hover\\:bg-card:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-card) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-gray-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-50) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-green-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-green-50) / var(--tw-bg-opacity, 1));
}

.hover\\:bg-primary\\/10:hover {
  background-color: rgb(var(--c-primary) / 0.1);
}

.hover\\:bg-white\\/20:hover {
  background-color: rgb(255 255 255 / 0.2);
}

.hover\\:text-\\[var\\(--primary\\)\\]:hover {
  color: var(--primary);
}

.hover\\:text-gray-700:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-700) / var(--tw-text-opacity, 1));
}

.hover\\:text-gray-800:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-gray-800) / var(--tw-text-opacity, 1));
}

.hover\\:text-primary:hover {
  --tw-text-opacity: 1;
  color: rgb(var(--c-primary) / var(--tw-text-opacity, 1));
}

.hover\\:underline:hover {
  text-decoration-line: underline;
}

.hover\\:shadow-lg:hover {
  --tw-shadow: 0 10px 15px -3px rgb(0 0 0 / 0.1), 0 4px 6px -4px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 10px 15px -3px var(--tw-shadow-color), 0 4px 6px -4px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}

.hover\\:text-primary:hover {
    color: var(--primary-text);
  }

.focus\\:not-sr-only:focus {
  position: static;
  width: auto;
  height: auto;
  padding: 0;
  margin: 0;
  overflow: visible;
  clip: auto;
  white-space: normal;
}

.focus\\:absolute:focus {
  position: absolute;
}

.focus\\:left-4:focus {
  left: 1rem;
}

.focus\\:top-4:focus {
  top: 1rem;
}

.focus\\:border-transparent:focus {
  border-color: transparent;
}

.focus\\:bg-gray-50:focus {
  --tw-bg-opacity: 1;
  background-color: rgb(var(--c-gray-50) / var(--tw-bg-opacity, 1));
}

.focus\\:outline-none:focus {
  outline: 2px solid transparent;
  outline-offset: 2px;
}

.focus\\:ring-2:focus {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus\\:ring-\\[var\\(--primary\\)\\]:focus {
  --tw-ring-color: var(--primary);
}

.focus\\:ring-blue-500:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-blue-500) / var(--tw-ring-opacity, 1));
}

.focus\\:ring-primary:focus {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-primary) / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-2:focus-visible {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(2px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}

.focus-visible\\:ring-current:focus-visible {
  --tw-ring-color: currentColor;
}

.focus-visible\\:ring-primary:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(var(--c-primary) / var(--tw-ring-opacity, 1));
}

.focus-visible\\:ring-white:focus-visible {
  --tw-ring-opacity: 1;
  --tw-ring-color: rgb(255 255 255 / var(--tw-ring-opacity, 1));
}

.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}

.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}

.disabled\\:opacity-60:disabled {
  opacity: 0.6;
}

@media (prefers-reduced-motion: no-preference) {

  @keyframes spin {

    to {
      transform: rotate(360deg);
    }
  }

  .motion-safe\\:animate-spin {
    animation: spin 1s linear infinite;
  }
}

@media (prefers-reduced-motion: reduce) {

  .motion-reduce\\:transition-none {
    transition-property: none;
  }
}

@media (min-width: 640px) {

  .sm\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .sm\\:mb-8 {
    margin-bottom: 2rem;
  }

  .sm\\:mr-3 {
    margin-right: 0.75rem;
  }

  .sm\\:h-12 {
    height: 3rem;
  }

  .sm\\:h-16 {
    height: 4rem;
  }

  .sm\\:h-20 {
    height: 5rem;
  }

  .sm\\:w-12 {
    width: 3rem;
  }

  .sm\\:w-16 {
    width: 4rem;
  }

  .sm\\:w-20 {
    width: 5rem;
  }

  .sm\\:w-auto {
    width: auto;
  }

  .sm\\:min-w-0 {
    min-width: 0px;
  }

  .sm\\:flex-shrink-0 {
    flex-shrink: 0;
  }

  .sm\\:flex-grow {
    flex-grow: 1;
  }

  .sm\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sm\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:justify-start {
    justify-content: flex-start;
  }

  .sm\\:gap-0 {
    gap: 0px;
  }

  .sm\\:gap-4 {
    gap: 1rem;
  }

  .sm\\:space-x-4 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-x-reverse: 0;
    margin-right: calc(1rem * var(--tw-space-x-reverse));
    margin-left: calc(1rem * calc(1 - var(--tw-space-x-reverse)));
  }

  .sm\\:space-y-0 > :not([hidden]) ~ :not([hidden]) {
    --tw-space-y-reverse: 0;
    margin-top: calc(0px * calc(1 - var(--tw-space-y-reverse)));
    margin-bottom: calc(0px * var(--tw-space-y-reverse));
  }

  .sm\\:rounded-l-lg {
    border-top-left-radius: 0.5rem;
    border-bottom-left-radius: 0.5rem;
  }

  .sm\\:rounded-l-none {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }

  .sm\\:rounded-r-lg {
    border-top-right-radius: 0.5rem;
    border-bottom-right-radius: 0.5rem;
  }

  .sm\\:rounded-r-none {
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .sm\\:p-6 {
    padding: 1.5rem;
  }

  .sm\\:p-8 {
    padding: 2rem;
  }

  .sm\\:text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
  }

  .sm\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .sm\\:text-lg {
    font-size: 1.125rem;
    line-height: 1.75rem;
  }

  .sm\\:text-xs {
    font-size: 0.75rem;
    line-height: 1rem;
  }
}

@media (min-width: 768px) {

  .md\\:order-2 {
    order: 2;
  }

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .md\\:mb-0 {
    margin-bottom: 0px;
  }

  .md\\:mt-0 {
    margin-top: 0px;
  }

  .md\\:w-1\\/2 {
    width: 50%;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-start {
    align-items: flex-start;
  }

  .md\\:text-left {
    text-align: left;
  }

  .md\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }

  .md\\:text-sm {
    font-size: 0.875rem;
    line-height: 1.25rem;
  }

  .md\\:text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
  }
}

@media (min-width: 1024px) {

  .lg\\:order-1 {
    order: 1;
  }

  .lg\\:order-2 {
    order: 2;
  }

  .lg\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .lg\\:col-span-7 {
    grid-column: span 7 / span 7;
  }

  .lg\\:mb-0 {
    margin-bottom: 0px;
  }

  .lg\\:aspect-\\[16\\/11\\] {
    aspect-ratio: 16/11;
  }

  .lg\\:w-1\\/2 {
    width: 50%;
  }

  .lg\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .lg\\:flex-row {
    flex-direction: row;
  }

  .lg\\:items-start {
    align-items: flex-start;
  }

  .lg\\:items-center {
    align-items: center;
  }

  .lg\\:pb-24 {
    padding-bottom: 6rem;
  }

  .lg\\:pl-12 {
    padding-left: 3rem;
  }

  .lg\\:pt-14 {
    padding-top: 3.5rem;
  }

  .lg\\:text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
  }

  .lg\\:text-5xl {
    font-size: 3rem;
    line-height: 1;
  }
}

@media (min-width: 1280px) {

  .xl\\:block {
    display: block;
  }

  .xl\\:flex {
    display: flex;
  }

  .xl\\:inline-flex {
    display: inline-flex;
  }

  .xl\\:hidden {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,uCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,iCAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,iCAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;EAAd;IAAA,mBAAc;;IAAd,SAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,oBAAc,EAAd,YAAc;IAAd,SAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,UAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,QAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,qBAAc,EAAd,YAAc;IAAd,WAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,UAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,WAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,WAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,SAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,qBAAc,EAAd,YAAc;;IAAd,oCAAc;IAAd,uBAAc,KAAd,sCAAc;IAAd,wBAAc,IAAd,0BAAc;IAAd,wBAAc,IAAd,mCAAc;IAAd,0BAAc,EAAd,uCAAc;IAAd,qBAAc,OAAd,YAAc;;IAAd,oEAAc;IAAd,uBAAc;IAAd,yBAAc;IAAd,wBAAc;;IAAd,+CAAc;IAAd,sBAAc,IAAd,YAAc;IAAd,qBAAc,KAAd,YAAc;IAAd,uBAAc,GAAd,YAAc;IAAd,iBAAc,SAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,qBAAc,KAAd,YAAc;;IAAd,uCAAc;IAAd,oBAAc,YAAd,YAAc;IAAd,0BAAc,MAAd,YAAc;IAAd,4BAAc,IAAd,YAAc;IAAd,yBAAc,OAAd,YAAc;;IAAd,2EAAc;IAAd,kBAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,oBAAc;IAAd,gBAAc;IAAd,gBAAc;IAAd,eAAc;IAAd,iBAAc;IAAd,cAAc;IAAd,mBAAc;IAAd,eAAc;IAAd,qBAAc;IAAd,qBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,kBAAc;;IAAd,0DAAc;IAAd,kBAAc;IAAd,sBAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,8BAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,4BAAc;IAAd,0BAAc;IAAd,qBAAc;EAAA;;EAAd;IAAA,kBAAc;;IAAd,SAAc;IAAd,qBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,SAAc;IAAd,qBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,UAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,QAAc;IAAd,oBAAc,EAAd,YAAc;IAAd,qBAAc,EAAd,YAAc;IAAd,qBAAc,EAAd,YAAc;IAAd,qBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,WAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,UAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,WAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,0BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,WAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,wBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,2BAAc,EAAd,YAAc;IAAd,SAAc;IAAd,qBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,sBAAc,EAAd,YAAc;IAAd,uBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;;IAAd;0DAAc;IAAd,uBAAc,KAAd,YAAc;IAAd,wBAAc,IAAd,YAAc;IAAd,wBAAc,IAAd,YAAc;IAAd,wBAAc,IAAd,YAAc;IAAd,qBAAc,OAAd,YAAc;;IAAd,gEAAc;IAAd,uBAAc;IAAd,yBAAc;IAAd,wBAAc;;IAAd,oBAAc;IAAd,mBAAc,OAAd,YAAc;IAAd,kBAAc,QAAd,YAAc;IAAd,oBAAc,MAAd,YAAc;IAAd,oBAAc,MAAd,YAAc;IAAd,yBAAc,EAAd,YAAc;IAAd,kBAAc,QAAd,YAAc;;IAAd,0EAAc;IAAd,oBAAc,YAAd,YAAc;IAAd,0BAAc,MAAd,YAAc;IAAd,4BAAc,IAAd,YAAc;IAAd,yBAAc,OAAd,YAAc;;IAAd,kBAAc;IAAd,oBAAc;IAAd,mBAAc;IAAd,oBAAc;IAAd,gBAAc;IAAd,gBAAc;IAAd,eAAc;IAAd,iBAAc;IAAd,cAAc;IAAd,mBAAc;IAAd,eAAc;IAAd,qBAAc;IAAd,qBAAc;IAAd,gBAAc;IAAd,kBAAc;IAAd,kBAAc;;IAAd,kBAAc;IAAd,sBAAc;IAAd,4BAAc;IAAd,4BAAc;IAAd,8BAAc;IAAd,sBAAc;IAAd,oBAAc;IAAd,4BAAc;IAAd,0BAAc;IAAd,qBAAc;EAAA;;EAAd;IAAA,0FAAc;IAAd,mCAAc;IAAd,wBAAc;EAAA;;EAAd;;;yFAAc;EAAd;;;IAAA,gCAAc;IAAd,wBAAc;EAAA;;EAAd;IAAA,6BAAc;IAAd,UAAc;EAAA;;EAAd;;IAAA,6BAAc;IAAd,UAAc;EAAA;AACd;EAAA,sBAAoB;EAApB,6BAAoB;EAApB,4BAAoB;EAApB,gCAAoB;EAApB;AAAoB;AAApB;EAAA,WAAoB;EAApB,kBAAoB;EAApB,iBAAoB;EAApB,qBAAoB;EAApB;AAAoB;AAkYlB;;;;;kCAKgC;AAChC;IACE,4BAAiB;EACnB;AAFA;IACE,iBAAiB;EACnB;AAGE;EAAA,qBAAiF;EAAjF,iBAAiF;EAAjF,oBAAiF;EAAjF,qBAAiF;EAAjF,mBAAiF;EAAjF,sBAAiF;EAAjF,gBAAiF;EAAjF,+FAAiF;EAAjF,wDAAiF;EAAjF,0BAAiF;IACjF,gCAAgC;IAChC;AAFiF;AAKnF;IACE,0CAA0C;EAC5C;AAGE;EAAA,qBAAiF;EAAjF,iBAAiF;EAAjF,oBAAiF;EAAjF,qBAAiF;EAAjF,mBAAiF;EAAjF,sBAAiF;EAAjF,gBAAiF;EAAjF,+FAAiF;EAAjF,wDAAiF;EAAjF,0BAAiF;IACjF,kCAAkC;IAClC;AAFiF;AAKnF;IACE,4CAA4C;EAC9C;AAEA;yFACuF;AACvF;IACE,iFAAiF;IACjF,wBAAwB;EAC1B;AAEA;IACE,6FAA6F;EAC/F;AAEA;IACE,0BAA0B;EAC5B;AAMA;IACE,WAAW;IACX,wFAAwF;IACxF,cAAc;IACd,UAAU;EACZ;AAGE;EAAA,qBAAmE;EAAnE,iBAAmE;EAAnE,sBAAmE;EAAnE,8BAAmE;EAAnE,uGAAmE;EAAnE,+FAAmE;EAAnE,wDAAmE;EAAnE,0BAAmE;IACnE,gCAAgC;IAChC;AAFmE;AAKrE;IACE,sCAAsC;EACxC;AAEA;IACE,mBAAmB;IACnB,4BAAuB;SAAvB,uBAAuB;IACvB,aAAa;IACb,iBAAiB;EACnB;AAEA;IACE;MACE,aAAa;IACf;EACF;AA9cF;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,SAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,oDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,sDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,8EAAmB;EAAnB,0EAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,4EAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,iFAAmB;EAAnB,2EAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,4EAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,4EAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,0EAAmB;EAAnB,8FAAmB;EAAnB;AAAmB;AAAnB;EAAA,+EAAmB;EAAnB,mGAAmB;EAAnB;AAAmB;AAAnB;EAAA,6EAAmB;EAAnB,iGAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,uCAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,+FAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAkdjB;;;;;;4FAM0F;AAC1F;IACE,0BAA0B;EAC5B;AAEA;IACE,4BAA4B;EAC9B;AAEA;IACE,2BAA2B;EAC7B;AAneF;EAAA;AAAmB;;AAEnB;;;;;;;;;;;;;;;;;;gFAkBgF;;AAtBhF;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA,2GA2eA;EA3eA,yGA2eA;EA3eA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,kBA2eA;EA3eA,kBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,sBA2eA;EA3eA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA,sBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,kBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,kBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,kBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,kBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,kBA2eA;EA3eA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA,+EA2eA;EA3eA,mGA2eA;EA3eA;AA2eA;;AAhBE;IACE,0BAA0B;EAC5B;;AA7dF;EAAA,gBA2eA;EA3eA,WA2eA;EA3eA,YA2eA;EA3eA,UA2eA;EA3eA,SA2eA;EA3eA,iBA2eA;EA3eA,UA2eA;EA3eA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA,kBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,8BA2eA;EA3eA;AA2eA;;AA3eA;EAAA,2GA2eA;EA3eA,yGA2eA;EA3eA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,2GA2eA;EA3eA,yGA2eA;EA3eA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA,oBA2eA;EA3eA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;EAAA;AA2eA;;AA3eA;;EAAA;;IAAA;MAAA;IA2eA;EAAA;;EA3eA;IAAA;EA2eA;AAAA;;AA3eA;;EAAA;IAAA;EA2eA;AAAA;;AA3eA;;EAAA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA,uBA2eA;IA3eA,oDA2eA;IA3eA;EA2eA;;EA3eA;IAAA,uBA2eA;IA3eA,2DA2eA;IA3eA;EA2eA;;EA3eA;IAAA,8BA2eA;IA3eA;EA2eA;;EA3eA;IAAA,2BA2eA;IA3eA;EA2eA;;EA3eA;IAAA,+BA2eA;IA3eA;EA2eA;;EA3eA;IAAA,4BA2eA;IA3eA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA,mBA2eA;IA3eA;EA2eA;;EA3eA;IAAA,kBA2eA;IA3eA;EA2eA;;EA3eA;IAAA,mBA2eA;IA3eA;EA2eA;;EA3eA;IAAA,kBA2eA;IA3eA;EA2eA;AAAA;;AA3eA;;EAAA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA,eA2eA;IA3eA;EA2eA;;EA3eA;IAAA,mBA2eA;IA3eA;EA2eA;;EA3eA;IAAA,kBA2eA;IA3eA;EA2eA;AAAA;;AA3eA;;EAAA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA,kBA2eA;IA3eA;EA2eA;;EA3eA;IAAA,eA2eA;IA3eA;EA2eA;AAAA;;AA3eA;;EAAA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;;EA3eA;IAAA;EA2eA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\n/* ---------------------------------------------------------------------------\n   Theming.\n\n   Every palette value lives in a CSS variable as \"R G B\" channels (Tailwind wraps\n   them in rgb(… / <alpha-value>) — see tailwind.config.js). The light block below is\n   the design system exactly as it shipped; the dark block re-points the same names.\n\n   The dark neutral/accent ramps are *mirrors* of the light ones: shades 50–300 are\n   recessive surfaces and 400–950 are progressively lighter foregrounds. That keeps\n   the relative ordering a component already relies on — `bg-gray-50` stays a step\n   back from `bg-card`, `text-gray-700` stays body copy — so existing markup themes\n   itself with no `dark:` variants. Two exceptions are given their own tokens because\n   inverting them would be wrong: the footer (a dark band in both themes) and solid\n   brand/accent fills that must keep carrying white text.\n\n   `data-theme` is written to <html> by src/theme/ThemeProvider.tsx, which resolves the\n   \"auto\" preference from prefers-color-scheme. public/index.html sets it before first\n   paint so the page never flashes the wrong theme.\n   --------------------------------------------------------------------------- */\n\n@layer base {\n  :root {\n    color-scheme: light;\n\n    /* gray */\n    --c-gray-50: 249 250 251; /* #f9fafb */\n    --c-gray-100: 243 244 246; /* #f3f4f6 */\n    --c-gray-200: 229 231 235; /* #e5e7eb */\n    --c-gray-300: 209 213 219; /* #d1d5db */\n    --c-gray-400: 156 163 175; /* #9ca3af */\n    --c-gray-500: 107 114 128; /* #6b7280 */\n    --c-gray-600: 75 85 99; /* #4b5563 */\n    --c-gray-700: 55 65 81; /* #374151 */\n    --c-gray-800: 31 41 55; /* #1f2937 */\n    --c-gray-900: 17 24 39; /* #111827 */\n    --c-gray-950: 3 7 18; /* #030712 */\n    /* blue */\n    --c-blue-50: 239 246 255; /* #eff6ff */\n    --c-blue-100: 219 234 254; /* #dbeafe */\n    --c-blue-200: 191 219 254; /* #bfdbfe */\n    --c-blue-300: 147 197 253; /* #93c5fd */\n    --c-blue-400: 96 165 250; /* #60a5fa */\n    --c-blue-500: 59 130 246; /* #3b82f6 */\n    --c-blue-600: 37 99 235; /* #2563eb */\n    --c-blue-700: 29 78 216; /* #1d4ed8 */\n    --c-blue-800: 30 64 175; /* #1e40af */\n    --c-blue-900: 30 58 138; /* #1e3a8a */\n    --c-blue-950: 23 37 84; /* #172554 */\n    /* green */\n    --c-green-50: 240 253 244; /* #f0fdf4 */\n    --c-green-100: 220 252 231; /* #dcfce7 */\n    --c-green-200: 187 247 208; /* #bbf7d0 */\n    --c-green-300: 134 239 172; /* #86efac */\n    --c-green-400: 74 222 128; /* #4ade80 */\n    --c-green-500: 34 197 94; /* #22c55e */\n    --c-green-600: 22 163 74; /* #16a34a */\n    --c-green-700: 21 128 61; /* #15803d */\n    --c-green-800: 22 101 52; /* #166534 */\n    --c-green-900: 20 83 45; /* #14532d */\n    --c-green-950: 5 46 22; /* #052e16 */\n    /* red */\n    --c-red-50: 254 242 242; /* #fef2f2 */\n    --c-red-100: 254 226 226; /* #fee2e2 */\n    --c-red-200: 254 202 202; /* #fecaca */\n    --c-red-300: 252 165 165; /* #fca5a5 */\n    --c-red-400: 248 113 113; /* #f87171 */\n    --c-red-500: 239 68 68; /* #ef4444 */\n    --c-red-600: 220 38 38; /* #dc2626 */\n    --c-red-700: 185 28 28; /* #b91c1c */\n    --c-red-800: 153 27 27; /* #991b1b */\n    --c-red-900: 127 29 29; /* #7f1d1d */\n    --c-red-950: 69 10 10; /* #450a0a */\n    /* yellow */\n    --c-yellow-50: 254 252 232; /* #fefce8 */\n    --c-yellow-100: 254 249 195; /* #fef9c3 */\n    --c-yellow-200: 254 240 138; /* #fef08a */\n    --c-yellow-300: 253 224 71; /* #fde047 */\n    --c-yellow-400: 250 204 21; /* #facc15 */\n    --c-yellow-500: 234 179 8; /* #eab308 */\n    --c-yellow-600: 202 138 4; /* #ca8a04 */\n    --c-yellow-700: 161 98 7; /* #a16207 */\n    --c-yellow-800: 133 77 14; /* #854d0e */\n    --c-yellow-900: 113 63 18; /* #713f12 */\n    --c-yellow-950: 66 32 6; /* #422006 */\n    /* amber */\n    --c-amber-50: 255 251 235; /* #fffbeb */\n    --c-amber-100: 254 243 199; /* #fef3c7 */\n    --c-amber-200: 253 230 138; /* #fde68a */\n    --c-amber-300: 252 211 77; /* #fcd34d */\n    --c-amber-400: 251 191 36; /* #fbbf24 */\n    --c-amber-500: 245 158 11; /* #f59e0b */\n    --c-amber-600: 217 119 6; /* #d97706 */\n    --c-amber-700: 180 83 9; /* #b45309 */\n    --c-amber-800: 146 64 14; /* #92400e */\n    --c-amber-900: 120 53 15; /* #78350f */\n    --c-amber-950: 69 26 3; /* #451a03 */\n    /* orange */\n    --c-orange-50: 255 247 237; /* #fff7ed */\n    --c-orange-100: 255 237 213; /* #ffedd5 */\n    --c-orange-200: 254 215 170; /* #fed7aa */\n    --c-orange-300: 253 186 116; /* #fdba74 */\n    --c-orange-400: 251 146 60; /* #fb923c */\n    --c-orange-500: 249 115 22; /* #f97316 */\n    --c-orange-600: 234 88 12; /* #ea580c */\n    --c-orange-700: 194 65 12; /* #c2410c */\n    --c-orange-800: 154 52 18; /* #9a3412 */\n    --c-orange-900: 124 45 18; /* #7c2d12 */\n    --c-orange-950: 67 20 7; /* #431407 */\n    /* purple */\n    --c-purple-50: 250 245 255; /* #faf5ff */\n    --c-purple-100: 243 232 255; /* #f3e8ff */\n    --c-purple-200: 233 213 255; /* #e9d5ff */\n    --c-purple-300: 216 180 254; /* #d8b4fe */\n    --c-purple-400: 192 132 252; /* #c084fc */\n    --c-purple-500: 168 85 247; /* #a855f7 */\n    --c-purple-600: 147 51 234; /* #9333ea */\n    --c-purple-700: 126 34 206; /* #7e22ce */\n    --c-purple-800: 107 33 168; /* #6b21a8 */\n    --c-purple-900: 88 28 135; /* #581c87 */\n    --c-purple-950: 59 7 100; /* #3b0764 */\n    /* pink */\n    --c-pink-50: 253 242 248; /* #fdf2f8 */\n    --c-pink-100: 252 231 243; /* #fce7f3 */\n    --c-pink-200: 251 207 232; /* #fbcfe8 */\n    --c-pink-300: 249 168 212; /* #f9a8d4 */\n    --c-pink-400: 244 114 182; /* #f472b6 */\n    --c-pink-500: 236 72 153; /* #ec4899 */\n    --c-pink-600: 219 39 119; /* #db2777 */\n    --c-pink-700: 190 24 93; /* #be185d */\n    --c-pink-800: 157 23 77; /* #9d174d */\n    --c-pink-900: 131 24 67; /* #831843 */\n    --c-pink-950: 80 7 36; /* #500724 */\n\n    /* Brand fills — carry white text. */\n    --c-primary: 45 106 159;    /* #2d6a9f — blue, structure / trust */\n    --c-secondary: 63 158 68;   /* #3f9e44 — green, care */\n    --c-tertiary: 229 146 20;   /* #e59214 — amber, money / value */\n    --c-highlight: 229 115 115; /* #e57373 — coral, remainder returns */\n    --c-danger: 239 68 68;      /* #ef4444 */\n\n    /* Brand ink — the same hues, but tuned to be read *on* a surface. */\n    --primary-text: #2d6a9f;\n    --secondary-text: #3f9e44;\n    --tertiary-text: #e59214;\n\n    /* Surfaces / ink (money-flow design system). */\n    --c-paper: 245 248 252;   /* #f5f8fc */\n    --c-card: 255 255 255;    /* #ffffff */\n    --c-card-2: 238 243 249;  /* #eef3f9 */\n    --c-ink: 31 45 61;        /* #1f2d3d */\n    --c-ink-soft: 91 107 125; /* #5b6b7d */\n    --c-line: 224 232 241;    /* #e0e8f1 */\n\n    /* Footer band — dark in both themes. */\n    --c-footer: 17 24 39;           /* #111827 */\n    --c-footer-fg: 255 255 255;     /* #ffffff */\n    --c-footer-surface: 31 41 55;   /* #1f2937 */\n    --c-footer-line: 31 41 55;      /* #1f2937 */\n\n    /* Legacy aliases kept for hand-written CSS and bg-[var(--…)] call sites. */\n    --primary: #2d6a9f;\n    --secondary: #3f9e44;\n    --tertiary: #e59214;\n    --highlight: #e57373;\n    --coral: #e57373;\n    --paper: #f5f8fc;\n    --card: #ffffff;\n    --card-2: #eef3f9;\n    --ink: #1f2d3d;\n    --ink-soft: #5b6b7d;\n    --line: #e0e8f1;\n    --background: #ffffff;\n    --foreground: #333333;\n    --error: #d32020;\n    --warning: #d95020;\n    --success: #3f9e44;\n\n    /* Component-level surfaces that must not simply invert. */\n    --card-bg: #ffffff;\n    --card-border: #e0e0e0;\n    --card-border-hover: #d0d0d0;\n    --btn-primary-hover: #245a8a;\n    --btn-secondary-hover: #3d8b40;\n    --accent-from: #facc15;\n    --accent-to: #fb923c;\n    --accent-from-hover: #eab308;\n    --accent-to-hover: #f97316;\n    --accent-ink: #713f12;\n  }\n\n  :root[data-theme=\"dark\"] {\n    color-scheme: dark;\n\n    /* gray */\n    --c-gray-50: 18 25 36; /* #121924 */\n    --c-gray-100: 23 32 50; /* #172032 */\n    --c-gray-200: 34 45 63; /* #222d3f */\n    --c-gray-300: 47 61 82; /* #2f3d52 */\n    --c-gray-400: 125 143 166; /* #7d8fa6 */\n    --c-gray-500: 148 165 186; /* #94a5ba */\n    --c-gray-600: 173 188 205; /* #adbccd */\n    --c-gray-700: 200 211 224; /* #c8d3e0 */\n    --c-gray-800: 227 233 241; /* #e3e9f1 */\n    --c-gray-900: 241 245 250; /* #f1f5fa */\n    --c-gray-950: 248 250 252; /* #f8fafc */\n    /* blue */\n    --c-blue-50: 16 29 46; /* #101d2e */\n    --c-blue-100: 20 38 58; /* #14263a */\n    --c-blue-200: 28 53 80; /* #1c3550 */\n    --c-blue-300: 39 73 108; /* #27496c */\n    --c-blue-400: 74 140 207; /* #4a8ccf */\n    --c-blue-500: 98 164 232; /* #62a4e8 */\n    --c-blue-600: 130 187 243; /* #82bbf3 */\n    --c-blue-700: 166 207 248; /* #a6cff8 */\n    --c-blue-800: 198 225 251; /* #c6e1fb */\n    --c-blue-900: 223 238 253; /* #dfeefd */\n    --c-blue-950: 240 247 255; /* #f0f7ff */\n    /* green */\n    --c-green-50: 14 31 22; /* #0e1f16 */\n    --c-green-100: 18 41 29; /* #12291d */\n    --c-green-200: 26 58 41; /* #1a3a29 */\n    --c-green-300: 36 80 56; /* #245038 */\n    --c-green-400: 69 168 107; /* #45a86b */\n    --c-green-500: 85 191 126; /* #55bf7e */\n    --c-green-600: 116 211 150; /* #74d396 */\n    --c-green-700: 153 224 178; /* #99e0b2 */\n    --c-green-800: 191 236 205; /* #bfeccd */\n    --c-green-900: 221 245 229; /* #ddf5e5 */\n    --c-green-950: 240 251 244; /* #f0fbf4 */\n    /* red */\n    --c-red-50: 36 19 21; /* #241315 */\n    --c-red-100: 48 25 27; /* #30191b */\n    --c-red-200: 69 37 39; /* #452527 */\n    --c-red-300: 94 51 53; /* #5e3335 */\n    --c-red-400: 224 113 111; /* #e0716f */\n    --c-red-500: 239 132 130; /* #ef8482 */\n    --c-red-600: 243 157 155; /* #f39d9b */\n    --c-red-700: 247 184 182; /* #f7b8b6 */\n    --c-red-800: 250 210 209; /* #fad2d1 */\n    --c-red-900: 252 231 230; /* #fce7e6 */\n    --c-red-950: 254 244 243; /* #fef4f3 */\n    /* yellow */\n    --c-yellow-50: 36 31 13; /* #241f0d */\n    --c-yellow-100: 46 40 17; /* #2e2811 */\n    --c-yellow-200: 69 59 24; /* #453b18 */\n    --c-yellow-300: 92 79 33; /* #5c4f21 */\n    --c-yellow-400: 212 172 47; /* #d4ac2f */\n    --c-yellow-500: 226 189 71; /* #e2bd47 */\n    --c-yellow-600: 236 202 106; /* #ecca6a */\n    --c-yellow-700: 242 217 146; /* #f2d992 */\n    --c-yellow-800: 247 230 184; /* #f7e6b8 */\n    --c-yellow-900: 251 242 217; /* #fbf2d9 */\n    --c-yellow-950: 253 249 238; /* #fdf9ee */\n    /* amber */\n    --c-amber-50: 38 29 11; /* #261d0b */\n    --c-amber-100: 49 37 14; /* #31250e */\n    --c-amber-200: 73 55 21; /* #493715 */\n    --c-amber-300: 97 73 29; /* #61491d */\n    --c-amber-400: 223 160 44; /* #dfa02c */\n    --c-amber-500: 236 178 69; /* #ecb245 */\n    --c-amber-600: 243 195 104; /* #f3c368 */\n    --c-amber-700: 248 213 144; /* #f8d590 */\n    --c-amber-800: 251 228 183; /* #fbe4b7 */\n    --c-amber-900: 253 241 216; /* #fdf1d8 */\n    --c-amber-950: 254 248 237; /* #fef8ed */\n    /* orange */\n    --c-orange-50: 39 26 15; /* #271a0f */\n    --c-orange-100: 50 33 20; /* #322114 */\n    --c-orange-200: 73 48 28; /* #49301c */\n    --c-orange-300: 97 64 36; /* #614024 */\n    --c-orange-400: 224 138 68; /* #e08a44 */\n    --c-orange-500: 238 157 91; /* #ee9d5b */\n    --c-orange-600: 245 180 126; /* #f5b47e */\n    --c-orange-700: 249 201 162; /* #f9c9a2 */\n    --c-orange-800: 252 220 195; /* #fcdcc3 */\n    --c-orange-900: 253 236 219; /* #fdecdb */\n    --c-orange-950: 254 246 239; /* #fef6ef */\n    /* purple */\n    --c-purple-50: 30 19 48; /* #1e1330 */\n    --c-purple-100: 38 25 61; /* #26193d */\n    --c-purple-200: 54 37 85; /* #362555 */\n    --c-purple-300: 72 51 111; /* #48336f */\n    --c-purple-400: 176 136 232; /* #b088e8 */\n    --c-purple-500: 192 157 240; /* #c09df0 */\n    --c-purple-600: 205 178 244; /* #cdb2f4 */\n    --c-purple-700: 220 200 248; /* #dcc8f8 */\n    --c-purple-800: 233 220 251; /* #e9dcfb */\n    --c-purple-900: 243 236 253; /* #f3ecfd */\n    --c-purple-950: 250 247 254; /* #faf7fe */\n    /* pink */\n    --c-pink-50: 43 18 32; /* #2b1220 */\n    --c-pink-100: 55 24 42; /* #37182a */\n    --c-pink-200: 78 36 59; /* #4e243b */\n    --c-pink-300: 103 49 78; /* #67314e */\n    --c-pink-400: 236 132 182; /* #ec84b6 */\n    --c-pink-500: 242 153 195; /* #f299c3 */\n    --c-pink-600: 245 176 209; /* #f5b0d1 */\n    --c-pink-700: 248 200 223; /* #f8c8df */\n    --c-pink-800: 251 221 236; /* #fbddec */\n    --c-pink-900: 253 237 244; /* #fdedf4 */\n    --c-pink-950: 254 246 250; /* #fef6fa */\n\n    /* Brand fills. Nudged brighter so they read on a dark ground while still\n       clearing 4.5:1 against the white text they carry. */\n    --c-primary: 53 121 173;    /* #3579ad */\n    --c-secondary: 47 124 53;   /* #2f7c35 */\n    --c-tertiary: 166 105 12;   /* #a6690c */\n    --c-highlight: 176 78 78;   /* #b04e4e */\n    --c-danger: 192 57 47;      /* #c0392f */\n\n    /* Brand ink — lightened for legibility against dark surfaces. */\n    --primary-text: #7ab6e8;\n    --secondary-text: #6cc873;\n    --tertiary-text: #f0b452;\n\n    /* Surfaces / ink. */\n    --c-paper: 21 29 41;      /* #151d29 */\n    --c-card: 26 36 51;       /* #1a2433 */\n    --c-card-2: 33 44 61;     /* #212c3d */\n    --c-ink: 227 233 241;     /* #e3e9f1 */\n    --c-ink-soft: 167 182 200; /* #a7b6c8 */\n    --c-line: 42 54 72;       /* #2a3648 */\n\n    /* Footer sits a step *below* the page so it still reads as a base band. */\n    --c-footer: 13 19 28;           /* #0d131c */\n    --c-footer-fg: 200 211 224;     /* #c8d3e0 */\n    --c-footer-surface: 26 35 48;   /* #1a2330 */\n    --c-footer-line: 33 44 59;      /* #212c3b */\n\n    --primary: #3579ad;\n    --secondary: #2f7c35;\n    --tertiary: #a6690c;\n    --highlight: #b04e4e;\n    --coral: #d98a8a;\n    --paper: #151d29;\n    --card: #1a2433;\n    --card-2: #212c3d;\n    --ink: #e3e9f1;\n    --ink-soft: #a7b6c8;\n    --line: #2a3648;\n    --background: #0f151f;\n    --foreground: #c8d3e0;\n    --error: #f08a86;\n    --warning: #ee9d5b;\n    --success: #6cc873;\n\n    --card-bg: #1a2433;\n    --card-border: #2a3648;\n    --card-border-hover: #3a4a60;\n    --btn-primary-hover: #4189bd;\n    --btn-secondary-hover: #388d3f;\n    --accent-from: #87610a;\n    --accent-to: #95530f;\n    --accent-from-hover: #9c710c;\n    --accent-to-hover: #aa6111;\n    --accent-ink: #fdf6e3;\n  }\n\n  body {\n    font-family: 'Poppins', 'Century Gothic', ui-rounded, system-ui, -apple-system, sans-serif;\n    background-color: var(--background);\n    color: var(--foreground);\n  }\n\n  /* Text-entry controls carry no background class anywhere in the app, so under\n     `color-scheme: dark` the browser fills them with its own off-palette grey. Painting\n     them here keeps every form on the theme's surfaces without touching call sites.\n     Checkboxes and radios are excluded — they still want the native control rendering. */\n  input:not([type=\"checkbox\"]):not([type=\"radio\"]),\n  textarea,\n  select {\n    background-color: var(--card-bg);\n    color: var(--foreground);\n  }\n\n  input::placeholder,\n  textarea::placeholder {\n    color: rgb(var(--c-gray-400));\n    opacity: 1;\n  }\n}\n\n@layer components {\n  /* One smooth cap for the content column, rather than Tailwind's breakpoint-stepped\n     max-widths — the column grows with the viewport and simply stops here. `center: true`\n     in the config supplies the auto margins. Below the cap, max-width has no effect and the\n     column is fluid (100% minus the config's padding), so it collapses to smaller screens\n     without a separate media query. Section backgrounds stay full-bleed; only what sits\n     inside them is constrained. */\n  .container {\n    max-width: 1024px;\n  }\n\n  .btn-primary {\n    @apply px-6 py-2 rounded-full font-medium border-0 transition-colors duration-200;\n    background-color: var(--primary);\n    color: white;\n  }\n\n  .btn-primary:hover {\n    background-color: var(--btn-primary-hover);\n  }\n\n  .btn-secondary {\n    @apply px-6 py-2 rounded-full font-medium border-0 transition-colors duration-200;\n    background-color: var(--secondary);\n    color: white;\n  }\n\n  .btn-secondary:hover {\n    background-color: var(--btn-secondary-hover);\n  }\n\n  /* Amber gradient CTA. Kept as its own component because a mirrored yellow/orange ramp\n     would leave a bright fill under near-white text; both stops move together instead. */\n  .btn-accent {\n    background-image: linear-gradient(to right, var(--accent-from), var(--accent-to));\n    color: var(--accent-ink);\n  }\n\n  .btn-accent:hover {\n    background-image: linear-gradient(to right, var(--accent-from-hover), var(--accent-to-hover));\n  }\n\n  .highlight-text {\n    color: var(--primary-text);\n  }\n\n  .success-text {\n    color: var(--secondary-text);\n  }\n\n  .section-divider {\n    height: 4px;\n    background: linear-gradient(90deg, transparent 0%, var(--primary) 50%, transparent 100%);\n    margin: 0 auto;\n    width: 70%;\n  }\n\n  .card {\n    @apply border rounded-lg shadow-none transition-colors duration-200;\n    background-color: var(--card-bg);\n    border-color: var(--card-border);\n  }\n\n  .card:hover {\n    border-color: var(--card-border-hover);\n  }\n\n  .story-paragraph {\n    text-align: justify;\n    text-align-last: center;\n    hyphens: auto;\n    word-spacing: 1pt;\n  }\n\n  @media (max-width: 600px) {\n    .story-paragraph {\n      hyphens: none;\n    }\n  }\n}\n\n@layer utilities {\n  /* Brand colour used as *ink* rather than as a fill: these resolve to the lightened\n     variant in dark mode, where the fill-weight brand blue is unreadable on a dark surface.\n\n     Each rule deliberately shadows the identical utility Tailwind generates from the config\n     colour of the same name — same specificity, emitted later, so this one wins. `bg-primary`\n     and `border-primary` are left alone and keep the fill weight. Consequence: a `dark:`\n     variant of these three would lose to the rules below; the tokens make it unnecessary. */\n  .text-primary {\n    color: var(--primary-text);\n  }\n\n  .text-secondary {\n    color: var(--secondary-text);\n  }\n\n  .text-tertiary {\n    color: var(--tertiary-text);\n  }\n\n  .hover\\:text-primary:hover {\n    color: var(--primary-text);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
